export const HALF_A_SECOND = 500;
export const FIVE_SECONDS_IN_MS = 5000;
export const ONE_SECOND_IN_MILISECONDS = 1000;
export const THREE_SECONDS_IN_MILISECONDS = 3000;
export const ONE_MINUTE_IN_MILISECONDS = 60000;
export const AUTOFOCUS_DELAY_MS = 300;
export const THIRTY_MINUTES_IN_MS = 30 * 60 * 1000;
